import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation, getI18n } from "react-i18next";
import { Button, Image, Message } from "semantic-ui-react";

const Immersive3dTourExportAdMessage = observer(
  ({ t, tourHasReadiedImmersive3dTour, otherProduct1CheckoutPageLink }) => {
    const i18n = getI18n();
    const translationExists = key => typeof i18n !== "undefined" && i18n.exists(key);

    let message1 = translationExists("clientPanelMisc:immersive3dTourExportAdNotReadyMessage1")
      ? t("clientPanelMisc:immersive3dTourExportAdNotReadyMessage1")
      : "We are happy to announce that we can provide an Immersive 3D Tour of your property.";
    let message2 = translationExists("clientPanelMisc:immersive3dTourExportAdNotReadyMessage2")
      ? t("clientPanelMisc:immersive3dTourExportAdNotReadyMessage2")
      : "Ask more details from your provider now!";
    let buttonLabel = "";

    if (tourHasReadiedImmersive3dTour) {
      message1 = translationExists("clientPanelMisc:immersive3dTourExportAdPaidMessage1")
        ? t("clientPanelMisc:immersive3dTourExportAdPaidMessage1")
        : "Export a standalone lifetime license of this Immersive 3D Tour for offline viewing.";
      message2 = translationExists("clientPanelMisc:immersive3dTourExportAdPaidMessage2")
        ? t("clientPanelMisc:immersive3dTourExportAdPaidMessage2")
        : "This export is included in your package.";
      buttonLabel = translationExists("clientPanelMisc:immersive3dTourExportAdPaidButtonLabel")
        ? t("clientPanelMisc:immersive3dTourExportAdPaidButtonLabel")
        : "Export";
    }

    return (
      <div className="immersive-3d-tour">
        <Message icon>
          <Image src="/assets/images/trivaxis_sigil.svg" width="110" style={{ marginRight: "1rem" }} />
          <Message.Content>
            <Message.Header>{message1}</Message.Header>
            {message2}
            {tourHasReadiedImmersive3dTour && (
              <>
                <br />
                <br />
                <Button href={otherProduct1CheckoutPageLink} primary target="_blank">
                  {buttonLabel}
                </Button>
              </>
            )}
          </Message.Content>
        </Message>
      </div>
    );
  },
);

Immersive3dTourExportAdMessage.propTypes = {
  t: PropTypes.func.isRequired,
  tourHasReadiedImmersive3dTour: PropTypes.bool.isRequired,
  otherProduct1CheckoutPageLink: PropTypes.string,
};

export default withTranslation()(Immersive3dTourExportAdMessage);
